import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-detail',
  templateUrl: './workflow-detail.component.html',
  styleUrls: ['./workflow-detail.component.scss']
})
export class WorkflowDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
